export class Base {
    constructor (parameters) {
        this._ = {
            features: this._get_array('FEATURES'),
        };

        for ( const feature of this._.features ) {
            feature.install_in_instance(
                this,
                {
                    parameters: parameters || {},
                }
            )
        }
    }

    _get_chain () {
        const chain = [];
        let cls = this.constructor;
        while ( cls && cls !== Base ) {
            chain.push(cls);
            cls = cls.__proto__;
        }
        return chain.reverse();
    }

    _get_array (key) {
        const chain = this._get_chain();
        const values = [];
        let last = null;
        for ( const cls of chain ) {
            if ( cls[key] && cls[key] !== last ) {
                last = cls[key];
                values.push(...cls[key]);
            }
        }
        return values;
    }

    _get_object (key) {
        // TODO: check objects by reference - same object in a subclass shouldn't count
        const chain = this._get_chain();
        const values = {};
        for ( const cls of chain ) {
            if ( cls[key] ) {
                Object.assign(values, cls[key]);
            }
        }
        return values;
    }
}
